export default [
  {
    path: 'groupsList',
    name: 'GroupsList',
    meta: {
      title: '圈子'
    },
    component: () => import('../views/exerland/groups/groupsList.vue')
  },
  {
    path: 'overseasDetail',
    name: 'OverseasDetail',
    meta: {
      title: '星知乎'
    },
    component: () => import('../views/exerland/groups/overseasDetail.vue')
  },
  {
    path: 'topicCollectionList',
    name: 'TopicCollectionList',
    meta: {
      title: '话题合集'
    },
    component: () => import('../views/exerland/groups/topicCollectionList.vue')
  },
  {
    path: 'dynamicList',
    name: 'DynamicList',
    meta: {
      title: '话题列表'
    },
    component: () => import('../views/exerland/groups/dynamicList.vue')
  }
]
